const namespace = 'bravissimo/product-recommendations/';

export const GET_CONSTRUCTOR_RECOMMENDATIONS_SUCCESS = `${namespace}GET_CONSTRUCTOR_RECOMMENDATIONS_SUCCESS`;
export const GET_CONSTRUCTOR_RECOMMENDATIONS_REQUEST = `${namespace}GET_CONSTRUCTOR_RECOMMENDATIONS_REQUEST`;
export const GET_CONSTRUCTOR_RECOMMENDATIONS_FAILURE = `${namespace}GET_CONSTRUCTOR_RECOMMENDATIONS_FAILURE`;
